import React from 'react';
import './BrandOnboardingShopifyFAQ.scss';

const BrandOnboardingShopifyFAQ = () => {
  return (
    <div className='brand-onboarding-shopify-faq-outer'>
      <div className='brand-onboarding-shopify-faq-inner'>
        <div className='brand-onboarding-shopify-faq-header'>Shopify App FAQs</div>

        <div className='brand-onboarding-shopify-faq-questions-container'>
          <details className='brand-onboarding-shopify-faq-question-container'>
            <summary className='brand-onboarding-shopify-faq-question'>Where can I find my Shopify domain(s)?</summary>
            <div className='brand-onboarding-shopify-faq-answer'>
              When logged into your Shopify account, go to Settings → Domains. This will show you the domains utilized in that Shopify Storefront. If
              the brand utilizes more than one storefront, be sure to check this in each additional account.
            </div>
          </details>

          <details className='brand-onboarding-shopify-faq-question-container'>
            <summary className='brand-onboarding-shopify-faq-question'>What permissions do I need to create a Shopify app?</summary>
            <div className='brand-onboarding-shopify-faq-answer'>
              To build a custom app in Shopify, you need these permissions on your staff account:
              <ul>
                <li>
                  <b>App development → Develop apps</b> (required)
                </li>
                <li>
                  <b>Apps and sales channels → Manage and install apps and channels</b> (required){' '}
                </li>
              </ul>
              Note: If the app needs access to specific data (like Orders or Customers), your account must also have those same permissions in the
              store.
            </div>
          </details>

          <details className='brand-onboarding-shopify-faq-question-container'>
            <summary className='brand-onboarding-shopify-faq-question'>Where can I find documentation to send to technical teams?</summary>
            <div className='brand-onboarding-shopify-faq-answer'>
              Some users do not have the capabilities to create the ShopMy Shopify App. The same setup instructions can be found{' '}
              <a href='https://docs.shopmy.us/reference/create-shopmys-shopify-app' target='_blank' rel='noreferrer'>
                here
              </a>{' '}
              . Once you have the tokens, use your new brand login to come back to this onboarding step and input the tokens.
            </div>
          </details>
        </div>
      </div>
    </div>
  );
};

export default BrandOnboardingShopifyFAQ;
